/**
 * Chamber-entered links (for example the sponsor logo link) are often saved
 * without a scheme, such as "yoursalescompany.com". A bare value opens as a
 * path on the dashboard, so add https:// unless the link already has a web,
 * mail or phone scheme. Script and data links are dropped.
 */
export const getExternalLinkUrl = (url?: string | null): string | undefined => {
  const value = (url || '').trim();
  if (!value || /^(javascript|data|vbscript):/i.test(value)) return undefined;
  return /^(https?:\/\/|mailto:|tel:)/i.test(value) ? value : `https://${value.replace(/^\/+/, '')}`;
};
